import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { agendaPresetIdZodSchema } from "./agenda-preset-id";
import { agendaPreset_dynamicTimeZodEnum } from "./agenda-preset.dynamic-time";
import { agendaFilterZodObject } from "./agenda-preset.filters";

const agendaPresetEditCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("AGENDA_PRESET_EDIT_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    agendaPresetId: agendaPresetIdZodSchema,
    title: z.string().min(1),
    providerId: providerIdZodSchema,
    shared: z.boolean().optional(),
    dynamicTime: agendaPreset_dynamicTimeZodEnum.optional(),
    filters: z.array(agendaFilterZodObject).optional(),
    columnSettings: z
        .object({
            showExtras: z.boolean(),
            showDropIns: z.boolean(),
            showBlockings: z.boolean(),
        })
        .optional(),
});

type AgendaPresetEditCommand = z.infer<typeof agendaPresetEditCommandZodObject>;

const agendaPresetEditCommandFactoryParamsZodObject =
    agendaPresetEditCommandZodObject.omit({
        _id: true,
        _type: true,
    });
type FactoryParams = z.infer<
    typeof agendaPresetEditCommandFactoryParamsZodObject
>;

const agendaPresetEditCommandFactory = (params: FactoryParams) => {
    const agendaPresetEditCommand: AgendaPresetEditCommand = {
        ...params,
        _id: generateId({ prefix: "agenda_preset_add_command__" }),
        _type: "AGENDA_PRESET_EDIT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return agendaPresetEditCommand;
};

export {
    agendaPresetEditCommandFactory,
    agendaPresetEditCommandFactoryParamsZodObject,
    agendaPresetEditCommandZodObject,
};
export type {
    AgendaPresetEditCommand,
    FactoryParams as AgendaPresetEditCommandFactoryParams,
};
